<template>
  <f7-popup
    :tablet-fullscreen="true"
    class="demo-popup"
    :opened="showPopUp"
    @popup:closed="emitClosePopUp"
  >
    <f7-page>
      <f7-navbar :title="$t('Mapa')">
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
          />
        </f7-nav-right>
      </f7-navbar>

      <div style="height: 100%; width: 100%;">
        <GISEditorSigpac
          v-if="showPopUp"
          :zoom="100"
          name-map="mainMap"
          :tree-locations="parsedLocations"
          :center="center || geolocation || { latitude: 40.34155, longitude: -3.73012 }"
          :disabled-edit-parcel="false"
          :show-marker="(center == null && geolocation) ? true : false"
          :create-sector="true"
        />

        <f7-button
          class="margin-top margin-bottom bg-blue-Contracts margin-horizontal"
          button
          @click="saveGeometry"
        >
          {{ $t('common.save') }}
        </f7-button>
      </div>
    </f7-page>
  </f7-popup>
</template>

<script>
import { mapState } from 'pinia';
import { useGisEditorStore } from '@/js/stores/gisEditor';

import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import GISEditorSigpac from './GISEditorSigpac/GISEditorSigpac.vue';

export default {
  name: 'MapPopUp',
  components: { GISEditorSigpac },
  props: {
    popupOpened: { type: Boolean, default: false },
    locations: { type: Array, default: () => [] },
  },

  emits: [
    'popup-close',
    'geometry-saved',
  ],

  data() {
    return {
      showPopUp: this.popupOpened,
      parsedLocations: [],
      center: null,
      geolocation: null,
    };
  },
  computed: {
    ...mapState(useGisEditorStore, ['currentGeoFeature']),
  },
  watch: {
    async popupOpened(newValue) {
      if (newValue) {
        await this.getGeoLocation();
      }
      this.showPopUp = newValue;
    },
    locations() {
      this.parseLocations();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // this.resetAll();
      // if(this.popupOpened)
      //  const coords = await this.getGeoLocation();
      // this.parseLocations();
      /* const watchId = navigator.geolocation.watchPosition((pos) => {
        alert(`${pos.coords.latitude}   ${pos.coords.longitude}`);
        this.geolocation = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        };
        this.parseLocations();
      });
      */
    },
    emitClosePopUp() {
      this.showPopUp = false;
      this.$emit('popup-close');
    },
    parseLocations() {
      let parsedLocations = [];
      parsedLocations.push({ children: [] });
      for (let i = 0; i < this.locations.length; i += 1) {
        const element = this.locations[i];
        if (element.features) {
          parsedLocations[0].children.push({
            coordinates: {
              longitude: element.features[0].geometry.coordinates[0][0][0],
              latitude: element.features[0].geometry.coordinates[0][0][1],
            },
            geo_feature: element,
          });
        }
      }

      if (parsedLocations[0].children.length === 0) {
        parsedLocations = [];
      }
      if (parsedLocations.length > 0) {
        this.center = parsedLocations[0].children[0].coordinates;
      } else {
        this.center = null;
      }
      this.parsedLocations = parsedLocations;
    },
    saveGeometry() {
      if (this.currentGeoFeature !== undefined && this.currentGeoFeature != null) {
        this.$emit('geometry-saved', this.currentGeoFeature);
        // this.resetAll();
        this.emitClosePopUp();
      }
    },

    async getGeoLocation() {
      f7.preloader.show();
      try {
        const pos = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            resolve,
            reject,
            { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true },
          );
        });
        this.geolocation = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        };
        return this.geolocation;
      } catch {
        HiNotification.Alert('No es posible obtener información basada en la ubicación real de tu teléfono.  Verifica que tienes activa la ubicación en los ajustes.', 'Ubicación no disponible');
      } finally {
        f7.preloader.hide();
      }
      return null;
    },
    /*
    getGeoLocation() {
      navigator.geolocation.getCurrentPosition((pos) => {

        this.geolocation = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        };
      }, (err) => {

        alert('No podemos obtener a la ubicación');
      });
    },
    */
  },
};
</script>

<style scoped lang="scss">
.demo-popup {
  .page-content {
    background: var(--his-whispering-lilac);
  }
}
</style>
